import React, { useState } from 'react'
import styled from 'styled-components'
import { InView } from 'react-intersection-observer'
import Spacer from '../../lib/spacer'
import Odometer from '../../common/odometer'
import StretchRoutineScroller from './stretch_routine_scroller'
import InfoScroller from './info_scroller'
import StoreLinks from '../../common/store_links'
import useStretchConfig from './config'
import { useTranslation } from '../../lib/i18n'
import { STRETCH_COUNT } from '../../lib/product'

const Wrapper = styled.div`

`

export default () => {
    const [sliderIndex, setSliderIndex] = useState(0)
    // Starts at the real count so the pre-rendered HTML states the number.
    // The observer's first callback zeroes it to set up the count-up.
    const [count, setCount] = useState(STRETCH_COUNT)
    const config = useStretchConfig()
    const { t } = useTranslation(undefined, { keyPrefix: 'home.stretchesSection' })

    return (
        <Wrapper>
            <Spacer size={130} className="show-for-large" />
            <Spacer size={60} className="show-for-medium-only" />
            <Spacer size={50} className="show-for-small-only" />
            <div className="grid-container">
                <div className="grid-x align-spaced">
                    <div className="cell large-7 medium-12 text-center large-text-left">
                        <InView triggerOnce threshold={0.5} onChange={(inView) => setCount(inView ? STRETCH_COUNT : 0)}>
                            <h2 className="h1">
                                <Odometer value={count} />{t('headingSuffix')}
                                <br />
                                {t('headingLine2')}
                            </h2>
                        </InView>
                        <Spacer size={30} />
                        <div className="grid-x medium-align-center large-align-left">
                            <div className="cell medium-8 large-9">
                                <p className="lead">{t('lead1')}</p>
                                <p className="lead hide-for-small-only">{t('lead2')}</p>
                            </div>
                        </div>
                        <div className="hide-for-large">
                            <Spacer size={50} />
                            <StoreLinks />
                        </div>
                        <Spacer size={60} className="show-for-large" />
                        <div className="show-for-large grid-x medium-align-center large-align-left">
                            <div className="cell medium-8 large-9">
                                <div style={{ height: '400px' }}>
                                    <InfoScroller
                                        large
                                        config={config}
                                        sliderIndex={sliderIndex}
                                        setSliderIndex={setSliderIndex}
                                    />
                                </div>
                            </div>
                        </div>
                        <Spacer size={60} className="show-for-large" />
                    </div>
                    <div className="cell large-5 medium-9">
                        <Spacer size={70} className="show-for-medium-only" />
                        <Spacer size={50} className="show-for-small-only" />
                        <StretchRoutineScroller
                            sliderIndex={sliderIndex}
                            setSliderIndex={setSliderIndex}
                        />
                        <Spacer size={10} className="show-for-large" />
                        <StoreLinks right className="show-for-large" />
                    </div>
                    <div className="cell medium-9 hide-for-large">
                        <InfoScroller
                            config={config}
                            sliderIndex={sliderIndex}
                            setSliderIndex={setSliderIndex}
                        />
                    </div>
                </div>
            </div>
            <Spacer size={130} className="show-for-large" />
            <Spacer size={60} className="hide-for-large" />
        </Wrapper>
    )
}
